const { URL } = require('./url');

function readerAddress(value) {
    const url = new URL(value.includes('://') ? value : `https://${value}`);
    if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || url.pathname !== '/')
        throw new Error('Enter an HTTPS reader address without a path or login details');
    return url;
}

module.exports = { readerAddress };
